import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const RestaurantContext = createContext(null);

export function RestaurantProvider({ children }) {
  const [restaurants, setRestaurants] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchRestaurants = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/client/restaurants`);
      const list = res.data || [];
      setRestaurants(list);
      // Auto-select if only 1 or restore from sessionStorage
      const saved = sessionStorage.getItem("selectedRestaurantId");
      const match = saved ? list.find((r) => r.restaurant_id === saved) : null;
      if (match) {
        setSelected(match);
      } else if (list.length === 1) {
        setSelected(list[0]);
        sessionStorage.setItem("selectedRestaurantId", list[0].restaurant_id);
      }
    } catch {
      setRestaurants([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchRestaurants(); }, [fetchRestaurants]);

  const selectRestaurant = (rest) => {
    setSelected(rest);
    sessionStorage.setItem("selectedRestaurantId", rest.restaurant_id);
  };

  const clearSelection = () => {
    setSelected(null);
    sessionStorage.removeItem("selectedRestaurantId");
  };

  return (
    <RestaurantContext.Provider
      value={{ restaurants, selected, loading, selectRestaurant, clearSelection, fetchRestaurants }}
    >
      {children}
    </RestaurantContext.Provider>
  );
}

export const useRestaurant = () => {
  const ctx = useContext(RestaurantContext);
  if (!ctx) throw new Error("useRestaurant must be used within RestaurantProvider");
  return ctx;
};
